import React from 'react';
import { motion } from 'framer-motion';
import LEGAL_DETAILS from '../config/legal';

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.45, ease: 'easeOut' },
};

export default function LegalPageShell({ testId, title, subtitle, updatedAt, children }) {
  return (
    <main data-testid={testId} className="pt-32 pb-24">
      <section className="relative">
        <div className="absolute inset-x-0 top-0 h-72 bg-[radial-gradient(circle_at_top,rgba(0,153,214,0.12),transparent_70%)] pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            {...fadeUp}
            className="rounded-[28px] border border-white/5 bg-[#15171E]/80 backdrop-blur-xl p-8 md:p-12 shadow-[0_20px_80px_rgba(0,0,0,0.25)]"
          >
            <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#0099D6] mb-4">
              {LEGAL_DETAILS.companyName}
            </p>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-4">
              {title}
            </h1>
            <p className="text-lg text-slate-300 leading-relaxed max-w-3xl">
              {subtitle}
            </p>
            {updatedAt && (
              <p className="mt-6 text-sm text-slate-400">
                {'Derni\u00e8re mise \u00e0 jour : '}
                <span className="text-slate-200">{updatedAt}</span>
              </p>
            )}
          </motion.div>

          <motion.div {...fadeUp} transition={{ ...fadeUp.transition, delay: 0.08 }} className="mt-8 space-y-6">
            {children}
          </motion.div>
        </div>
      </section>
    </main>
  );
}
